const bottomNavigation = document.querySelector('[data-bottom-navigation]');

if (bottomNavigation) {
  bottomNavigation.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');

    if (!link) {
      return;
    }

    const target = document.querySelector(link.getAttribute('href'));

    if (target) {
      target.focus({ preventScroll: true });
    }
  });
}
